<script lang="ts">
  import { faDollarSign,faEye,faMousePointer,faRetweet } from '@fortawesome/free-solid-svg-icons';
  import { Badge,Card,CardBody,CardHeader,Col,Row } from 'sveltestrap';
  import type ActiveHeadline from '../model/activeHeadline';
  import { gamestate } from '../stores';
  import StarRating from './StarRating.svelte';
  import TurnGraphDisplay from './TurnGraphDisplay.svelte';

  export let headline: ActiveHeadline;
</script>

<div class="mb-3">
  <Card class={headline.writtenOn !== $gamestate.turn ? " bg-secondary bg-opacity-25" : ""}>
    <CardHeader>
      <strong>
        {headline.content.title}
        {#each headline.content.topics as topic}
          <Badge class="me-1">{topic}</Badge>
        {/each}
      </strong>
    </CardHeader>

    <CardBody>
      <div class="mb-2">
        <StarRating stars={headline.quality} />
        <StarRating stars={headline.content.clickbait} icon={faMousePointer} />

        {#if headline.writtenOn === $gamestate.turn}
          Last turn
        {:else}
          {$gamestate.turn - headline.writtenOn + 1} turns ago
        {/if}
      </div>

      <Row>
        <Col>
          <TurnGraphDisplay icon={faEye} graph={headline.views} />
        </Col>
        <Col>
          <TurnGraphDisplay icon={faRetweet} graph={headline.shares} />
        </Col>
        <Col>
          <TurnGraphDisplay icon={faDollarSign} graph={headline.revenue} />
        </Col>
      </Row>
    </CardBody>
  </Card>
</div>